// ./src/contexts/TravelSegmentsContext/TravelSegmentsContext.tsx
//
// Thin context wrapper around the useTravelSegments hook. All derived data lives
// in the hook itself. See TasksContext / TimelineItemsContext for the pattern.

import React, { createContext, useContext } from "react";

import { useTravelSegments, UseTravelSegmentsOptions, UseTravelSegmentsReturn } from "@/hooks/useTravelSegments";

const TravelSegmentsContext = createContext<UseTravelSegmentsReturn | null>(null);

export interface TravelSegmentsProviderProps extends UseTravelSegmentsOptions {
  children: React.ReactNode;
}

export const TravelSegmentsProvider: React.FC<TravelSegmentsProviderProps> = ({ children, ...options }) => {
  const value = useTravelSegments(options);

  return <TravelSegmentsContext.Provider value={value}>{children}</TravelSegmentsContext.Provider>;
};

export const useTravelSegmentsContext = (): UseTravelSegmentsReturn => {
  const context = useContext(TravelSegmentsContext);

  if (!context) {
    throw new Error(
      "useTravelSegmentsContext must be used within a <TravelSegmentsProvider>. " +
        "Wrap your component tree with <TravelSegmentsProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalTravelSegmentsContext = (): UseTravelSegmentsReturn | null => {
  return useContext(TravelSegmentsContext);
};
